import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Leaderboard from "../components/Leaderboard";
import PromoBanners from "../components/PromoBanners";
import VipTransfer from "../components/VipTransfer";
import Livestream from "../components/Livestream";
import Socials from "../components/Socials";
import Giveaways from "../components/Giveaways";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#2f2753]">
      <Header />
      <main>
        <Hero />
        <Leaderboard />
        <PromoBanners />
        <VipTransfer />
        <Livestream />
        <Giveaways />
        <Socials />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
